import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { UseInfiniteQueryResult, UseSuspenseInfiniteQueryResult } from '@tanstack/react-query';

const useInfiniteScroll = (props: UseInfiniteQueryResult | UseSuspenseInfiniteQueryResult) => {
    const { hasNextPage, fetchNextPage, isFetching } = props;
    const { ref, inView } = useInView();

    useEffect(() => {
        if (!isFetching && inView && hasNextPage) {
            fetchNextPage();
        }
    }, [isFetching, inView, hasNextPage, fetchNextPage]);

    return ref;
};

export { useInfiniteScroll };
